import Joi from 'joi';

/**
 * @method noOfCountAPISchema
 * @description schema definition for get no of count api response
 */

export const noOfCountAPISchema = Joi.array().items(
  Joi.object({
    journeys: {
      pendingApproval: Joi.number().optional(),
      returned: Joi.number().optional(),
      draft: Joi.number().optional(),
      active: Joi.number().optional(),
      inActive: Joi.number().optional(),
    },
    services: {
      pendingApproval: Joi.number().optional(),
      returned: Joi.number().optional(),
      draft: Joi.number().optional(),
      active: Joi.number().optional(),
      inActive: Joi.number().optional(),
    },
    events: {
      pendingApproval: Joi.number().optional(),
      returned: Joi.number().optional(),
      draft: Joi.number().optional(),
      active: Joi.number().optional(),
      inActive: Joi.number().optional(),
    }
  })
).options({ stripUnknown: true });

/**
 * @method plannedMaintenanceSchema
 * * @description schema validation for journeys execution status api response
 */
export const plannedMaintenanceSchema = Joi.object({
  serviceScheduleMaintenance: Joi.array()
    .items({
      version: Joi.number(),
      updatedBy: Joi.string(),
      updatedTimestamp: Joi.string(),
      serviceType: Joi.string().allow(''),
      maintenanceName: Joi.string(),
      startTimestamp: Joi.string(),
      endTimestamp: Joi.string(),
      maintenanceStatus: Joi.string(),
      impactedServicesList: Joi.array().items({
        serviceName: Joi.string().allow(''),
      })
    })
    .required(),
  metadata: Joi.object({
    pageNumber: Joi.number(),
    pageSize: Joi.number(),
    totalNumberOfPages: Joi.number(),
    totalNumberOfElements: Joi.number()
  }).required()
}).options({ stripUnknown: true });

/**
 * @method servicesSchema
 * * @description schema validation for get services api response
 */
// ValidationError: \"services[2].serviceOperations[0].ingressEvents[0].ingressConfig.requestSpecJson\" is not allowe
export const servicesSchema = Joi.object({
  services: Joi.array().items({
    uuid: Joi.string().allow(''),
    status: Joi.string().allow(''),
    version: Joi.number().allow(''),
    createdBy: Joi.string().allow(''),
    createdTimestamp: Joi.string().allow(''),
    updatedBy: Joi.string().allow(''),
    updatedTimestamp: Joi.string().allow(''),
    serviceName: Joi.string().allow(''),
    serviceType: Joi.string().allow(''),
    serviceCategory: Joi.string().allow(''),
    serviceDescription: Joi.string().allow(''),
    endPoint: Joi.string().allow(''),
    authDetails: Joi.object({
      authType: Joi.string().allow(''),
      authMethod: Joi.string().allow(''),
      authUrl: Joi.string().allow(''),
      username: Joi.string().allow(''),
      password: Joi.string().allow(''),
      queryPathParam: Joi.object(),
      headerParam: Joi.object(),
      requestParam: Joi.object(),
    }).optional(),
    serviceOperations: Joi.array().items(
      Joi.object({
        serviceOperation: Joi.string(),
        operationUrl: Joi.string().allow(''),
        operationVerb: Joi.string().allow(''),
        requestAttributes: Joi.array().items(Joi.string().allow('')),
        responseAttributes: Joi.array().items(Joi.string().allow('')),
        security: Joi.string().allow(''),
        ingressEvents: Joi.array().items(
          Joi.object({
            ingressEventName: Joi.string().allow(''),
            ingressEventVersion: Joi.string().allow(''),
            ingressConfig: Joi.object({
              mqRequestSpec: Joi.string().allow(''),
              exceptionMappings: Joi.array(),
              requestSpecJson: Joi.string().allow('').optional(),
              headerToRequestHeaderSpecJson: Joi.string().allow('').optional(),
              headerToRequestPayloadSpecJson: Joi.string().allow('').optional(),
              authSpecJson: Joi.string().allow('').optional(),
              payloadToQueryPathSpecJson: Joi.string().allow('').optional(),
              payloadToRequestHeaderSpecJson: Joi.string().allow('').optional(),
            }),
            egressEvents: Joi.array(),
          })
        ),
        queryPathParam: Joi.object(),
        headerParam: Joi.object(),
      })
    ),
    serviceExceptions: Joi.array(),
    soapAttributes: Joi.object({
      headersXML: Joi.string().allow(''),
      envelopeNamespaces: Joi.array().items({
        prefix: Joi.string().allow(''),
        namespace: Joi.string().allow('')
      })
    }).optional(),
    serviceStatusHistory: Joi.array().items(
      Joi.object({
        statusUuid: Joi.string().allow(''),
        status: Joi.string().allow(''),
        createdBy: Joi.string().allow(''),
        createdTimestamp: Joi.string().allow(''),
        comment: Joi.string().allow('').optional()
      })
    ),
  }),
  currentPageNumber: Joi.number(),
  numberOfRecordsPerPage: Joi.number(),
  numberOfPages: Joi.number(),
  totalRecords: Joi.number()
}).options({ stripUnknown: true });

/**
 * @method servicesSchema
 * * @description schema validation for save maintenance response
 */
export const saveMaintenanceSchema = Joi.object({
  uuid: Joi.string().allow(''),
  status: Joi.string().allow(''),
  version: Joi.number(),
  createdBy: Joi.string().allow(''),
  createdTimestamp: Joi.string().allow(''),
  updatedBy: Joi.string().allow(''),
  updatedTimestamp: Joi.string().allow(''),
  maintenanceName: Joi.string().allow(''),
  message: Joi.string().allow(''),
  startTimestamp: Joi.string().allow(''),
  endTimestamp: Joi.string().allow(''),
  usersEmail: Joi.array().items(Joi.string()),
  serviceType: Joi.string().allow(''),
  serviceAuditMaintenance: Joi.array().items({
    maintenanceAuditUuid: Joi.string().allow(''),
    maintenanceStatus: Joi.string().allow(''),
    createdBy: Joi.string().allow(''),
    createdTimeStamp: Joi.string().allow(''),
  }),
  impactedServices: Joi.array().items({
    serviceName: Joi.string().allow(''),
    serviceVersion: Joi.number()
  }),
  maintenanceStatus: Joi.string().allow('')
}).required();

/**
 * @method MaintenanceStatusSchema
 * * @description schema validation for MaintenanceStatusSchema response
 */
export const MaintenanceStatusSchema = Joi.object({
  uuid: Joi.string().allow(''),
  status: Joi.string().allow(''),
  version: Joi.number(),
  createdBy: Joi.string().allow(''),
  createdTimestamp: Joi.string().allow(''),
  updatedBy: Joi.string().allow(''),
  updatedTimestamp: Joi.string().allow(''),
  maintenanceName: Joi.string().allow(''),
  message: Joi.string().allow(''),
  startTimestamp: Joi.string().allow(''),
  endTimestamp: Joi.string().allow(''),
  usersEmail: Joi.array().items(Joi.string()),
  serviceType: Joi.string().allow(''),
  impactedServices: Joi.array().items({
    serviceName: Joi.string().allow(''),
    serviceVersion: Joi.number()
  }),
  maintenanceStatus: Joi.string().allow(''),
  serviceAuditMaintenance: Joi.array().items({
    maintenanceAuditUuid: Joi.string().allow(''),
    maintenanceStatus: Joi.string().allow(''),
    createdBy: Joi.string().allow(''),
    createdTimeStamp: Joi.string().allow(''),
  }),
}).required();

/**
 * @method BannerDataSchema
 * * @description schema validation for BannerDataSchema response
 */
export const BannerDataSchema = Joi.array()
  .items({
    maintenanceName: Joi.string().allow(''),
    message: Joi.string().allow(''),
    startTimestamp: Joi.string().allow(''),
    endTimestamp: Joi.string().allow(''),
    maintenanceStatus: Joi.string().allow(''),
  })
  .required();

export const SmLogHistorySchema = Joi.array().items({
  uuid: Joi.string().allow(''),
  status: Joi.string().allow(''),
  version: Joi.number(),
  createdBy: Joi.string().allow(''),
  createdTimestamp: Joi.string().allow(''),
  updatedBy: Joi.string().allow(''),
  updatedTimestamp: Joi.string().allow(''),
  maintenanceName: Joi.string().allow(''),
  message: Joi.string().allow(''),
  startTimestamp: Joi.string().allow(''),
  endTimestamp: Joi.string().allow(''),
  usersEmail: Joi.array(),
  impactedServices: Joi.array(),
  maintenanceStatus: Joi.string().allow(''),
  serviceType: Joi.string().allow(''),
  serviceAuditMaintenance: Joi.array()
    .items({
      maintenanceAuditUuid: Joi.string().allow(''),
      maintenanceStatus: Joi.string().allow(''),
      createdBy: Joi.string().allow(''),
      createdTimeStamp: Joi.string().allow('')
    })
}).options({ stripUnknown: true });

/**
 * @method ClearCacheSchema
 * * @description schema validation for ClearCacheSchema response
 */
export const ClearCacheSchema = Joi.object({
  message: Joi.string().allow(''),
  status: Joi.string().allow(''),
}).required();
